export function passwordValidator(input) {
  const regPass = /^(?=.*\d)(?=.*[_#?!@$%^&*-])(?=.*[A-Z])(?=.*[a-z])\S{8,}$/;
  const found = input.match(regPass);

  if (found !== null) {
    return 1;
  }
  return -1;
}
